<template>
  <MediumModal
    :is-open="open"
    @close="close"
  >
    <template #header> Receive Transfer </template>

    <div class="bg-gray-200 -mt-3 -mx-6 py-4 px-7 flex items-center justify-between">
      <div class="flex gap-3 items-center">
        <Menu
          as="div"
          class="relative text-right -mt-1 inline-block"
        >
          <div>
            <MenuButton
              class="inline-flex items-center justify-center w-full rounded-full border border-gray-400 px-3 py-1 bg-gray-100 text-sm font-medium text-blue-600 hover:bg-gray-300"
            >
              Homestead
            </MenuButton>
          </div>
        </Menu>

        <span class="font-medium text-xs">TO</span>

        <Menu
          as="div"
          class="relative text-right -mt-1 inline-block"
        >
          <div>
            <MenuButton
              class="inline-flex items-center justify-center w-full rounded-full border border-gray-400 px-3 py-1 bg-gray-100 text-sm font-medium text-blue-600 hover:bg-gray-300"
            >
              Inverness
            </MenuButton>
          </div>
        </Menu>
      </div>

      <DatePicker
        v-model="date"
        color="gray"
        title-position="right"
      >
        <template v-slot="{ inputValue, inputEvents }">
          <div class="relative">
            <CalendarIcon
              class="top-1.5 left-3 h-4 w-4 text-gray-400 absolute"
              aria-hidden="true"
            />
            <input
              class="inline-flex items-center w-36 justify-center pl-8 rounded-full border border-gray-400 px-3 py-1 bg-gray-100 text-sm font-medium text-blue-600 hover:bg-gray-300 cursor-pointer"
              :value="inputValue"
              v-on="inputEvents"
            />
          </div>
        </template>
      </DatePicker>
    </div>

    <div class="p-1 divide-y divide-gray-400">
      <div class="grid grid-cols-6 gap-5 py-3">
        <div class="col-span-2 text-left text-xs uppercase text-gray-600 font-semibold">
          <span>Package</span>
        </div>
        <div class="col-span-2 text-left text-xs uppercase text-gray-600 font-semibold">
          <span>Reason</span>
        </div>
        <div class="col-span-1 text-center text-xs uppercase text-gray-600 font-semibold">
          <span>Count</span>
        </div>
        <div class="col-span-1 text-center text-xs uppercase text-gray-600 font-semibold">
          <span>Actual</span>
        </div>
      </div>

      <div class="grid grid-cols-6 gap-5 py-3 items-center">
        <div class="col-span-2 text-left flex flex-col leading-tight">
          <span class="uppercase text-blue-600 font-semibold text-sm">Waffle Cone</span>
          <span class="text-gray-600 text-sm font-semibold">waffle-cone-305</span>
        </div>
        <div class="col-span-2"></div>
        <div class="col-span-1 text-center text-sm uppercase text-gray-600 font-semibold">
          <input
            class="rounded w-full border border-blue-600 text-blue-600 text-base px-3 py-1 font-semibold text-center"
            value="120"
          />
        </div>
        <div class="col-span-1 text-center text-sm uppercase text-gray-600 font-semibold">
          <input
            class="rounded w-full border border-blue-600 text-blue-600 text-base px-3 py-1 font-semibold text-center"
            value="120"
          />
        </div>
      </div>

      <div class="grid grid-cols-6 gap-5 py-3 items-center">
        <div class="col-span-2 text-left flex flex-col leading-tight">
          <span class="uppercase text-red-600 font-semibold text-sm">Waffle Cone</span>
          <span class="text-gray-600 text-sm font-semibold">waffle-cone-305</span>
        </div>
        <div class="col-span-2"></div>
        <div class="col-span-1 text-center text-sm uppercase text-gray-600 font-semibold">
          <input
            class="rounded w-full border-red-600 border text-red-600 text-base px-3 py-1 font-semibold text-center"
            value="120"
          />
        </div>
        <div class="col-span-1 text-center text-sm uppercase text-gray-600 font-semibold">
          <input
            class="rounded w-full border-red-600 border text-red-600 text-base px-3 py-1 font-semibold text-center"
            value="125"
          />
        </div>
      </div>

      <div class="grid grid-cols-6 gap-5 py-1 items-center divide-none border-0 border-none">
        <div class="col-span-2 text-left flex flex-col leading-tight"></div>
        <div class="col-span-2 flex items-center gap-2">
          <Menu
            as="div"
            class="relative text-left inline-block w-full"
          >
            <div>
              <MenuButton
                class="inline-flex items-center w-full justify-between rounded border border-gray-400 px-3 py-2 bg-gray-100 text-sm font-medium text-blue-600 hover:bg-gray-300"
              >
                Reason
                <ChevronDownIcon
                  class="-mr-1 ml-2 h-4 w-4 text-gray-400"
                  aria-hidden="true"
                />
              </MenuButton>
            </div>
            <transition
              enter-active-class="transition ease-out duration-100"
              enter-from-class="opacity-0 scale-95"
              enter-to-class="opacity-100 scale-100"
              leave-active-class="transition ease-in duration-75"
              leave-from-class="opacity-100 scale-100"
              leave-to-class="opacity-0 scale-95"
            >
              <MenuItems
                class="justify-end origin-top-right absolute right-0 mt-2 w-full rounded-md shadow-lg bg-gray-100 divide-y divide-gray-400 focus:outline-none z-50"
              >
                <div class="">
                  <MenuItem v-slot="{ active }">
                    <a
                      href="#"
                      :class="[
                        active ? 'bg-gray-400 text-gray-900' : 'text-gray-700',
                        'group flex items-center px-4 py-2 text-sm hover:bg-blue-600 hover:text-gray-100'
                      ]"
                    >
                      Damaged
                    </a>
                  </MenuItem>
                  <MenuItem v-slot="{ active }">
                    <a
                      href="#"
                      :class="[
                        active ? 'bg-gray-400 text-gray-900' : 'text-gray-700',
                        'group flex items-center px-4 py-2 text-sm hover:bg-blue-600 hover:text-gray-100'
                      ]"
                    >
                      Missing
                    </a>
                  </MenuItem>
                </div>
              </MenuItems>
            </transition>
          </Menu>
        </div>
        <div class="col-span-1 text-center text-sm uppercase text-gray-600 font-semibold">
          <input
            class="rounded w-full border-red-600 border text-red-600 text-base px-3 py-1 font-semibold text-center"
          />
        </div>
        <div class="col-span-1 text-center text-sm uppercase text-gray-600 font-semibold">
          <a @click="addItem()">
            <!-- <MinusCircleIcon class="h-5 w-5 text-gray-300" aria-hidden="true" /> -->
            <img
              :src="asset('images/minus.svg')"
              style="width: 18px"
              class="text-gray-300 mx-auto"
            />
          </a>
        </div>
      </div>

      <div class="grid grid-cols-6 gap-5 py-1 items-center divide-none border-0 border-none">
        <div class="col-span-2 text-left flex flex-col leading-tight"></div>
        <div class="col-span-2 flex items-center gap-2">
          <Menu
            as="div"
            class="relative text-left inline-block w-full"
          >
            <div>
              <MenuButton
                class="inline-flex items-center w-full justify-between rounded border border-gray-400 px-3 py-2 bg-gray-100 text-sm font-medium text-blue-600 hover:bg-gray-300"
              >
                Reason
                <ChevronDownIcon
                  class="-mr-1 ml-2 h-4 w-4 text-gray-400"
                  aria-hidden="true"
                />
              </MenuButton>
            </div>
            <transition
              enter-active-class="transition ease-out duration-100"
              enter-from-class="opacity-0 scale-95"
              enter-to-class="opacity-100 scale-100"
              leave-active-class="transition ease-in duration-75"
              leave-from-class="opacity-100 scale-100"
              leave-to-class="opacity-0 scale-95"
            >
              <MenuItems
                class="justify-end origin-top-right absolute right-0 mt-2 w-full rounded-md shadow-lg bg-gray-100 divide-y divide-gray-400 focus:outline-none z-50"
              >
                <div class="">
                  <MenuItem v-slot="{ active }">
                    <a
                      href="#"
                      :class="[
                        active ? 'bg-gray-400 text-gray-900' : 'text-gray-700',
                        'group flex items-center px-4 py-2 text-sm hover:bg-blue-600 hover:text-gray-100'
                      ]"
                    >
                      Damaged
                    </a>
                  </MenuItem>
                  <MenuItem v-slot="{ active }">
                    <a
                      href="#"
                      :class="[
                        active ? 'bg-gray-400 text-gray-900' : 'text-gray-700',
                        'group flex items-center px-4 py-2 text-sm hover:bg-blue-600 hover:text-gray-100'
                      ]"
                    >
                      Missing
                    </a>
                  </MenuItem>
                </div>
              </MenuItems>
            </transition>
          </Menu>
        </div>
        <div class="col-span-1 text-center text-sm uppercase text-gray-600 font-semibold">
          <input
            class="rounded w-full border-red-600 border text-red-600 text-base px-3 py-1 font-semibold text-center"
          />
        </div>
        <div class="col-span-1 text-center text-sm uppercase text-gray-600 font-semibold">
          <a @click="addItem()">
            <!-- <MinusCircleIcon class="h-5 w-5 text-gray-300" aria-hidden="true" /> -->
            <img
              :src="asset('images/minus.svg')"
              style="width: 18px"
              class="text-gray-300 mx-auto"
            />
          </a>
        </div>
      </div>

      <div class="grid grid-cols-6 gap-5 py-3 items-center divide-none border-0 border-none">
        <div class="col-span-2 text-left flex flex-col leading-tight"></div>
        <div class="col-span-2 flex items-center"></div>
        <div class="col-span-1 flex items-center"></div>
        <div class="col-span-1 text-center text-sm uppercase text-gray-600 font-semibold">
          <a
            @click="addItem()"
            class="block text-center"
          >
            <!-- <MinusCircleIcon class="h-5 w-5 text-gray-300" aria-hidden="true" /> -->
            <img
              :src="asset('images/plus.svg')"
              style="width: 18px"
              class="text-gray-300 mx-auto"
            />
          </a>
        </div>
      </div>
    </div>

    <div class="border-t-2 border-blue-600">
      <div class="mt-3 bg-gray-200 p-3">
        <div class="flex justify-between text-blue-600 font-semibold uppercase text-sm">
          <div>Total Sent</div>
          <div>150</div>
        </div>
        <div class="flex justify-between text-red-600 font-semibold uppercase text-sm mt-2">
          <div>Total Received</div>
          <div>140</div>
        </div>
      </div>
    </div>

    <template #footer>
      <!-- WARNING -->
      <div class="bg-blue-600 py-4 px-6 text-gray-100 rounded-b -mx-6 -my-6">
        <div class="flex items-center gap-3 justify-between">
          <div class="flex items-center gap-3">
            <ExclamationCircleIcon
              class="h-7 w-7 text-gray-100"
              aria-hidden="true"
            />
            <span class="text-gray-100 leading-snug block text-xs font-semibold"
              >CONFIRM! Please confirm receipt of this transfer.</span
            >
          </div>

          <div class="flex gap-3">
            <button
              @click.prevent="submit()"
              :disabled="creating"
              type="button"
              class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-blue-600 bg-gray-100 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-100"
            >
              Complete
            </button>
          </div>
        </div>
      </div>

      <!-- <div class="justify-end flex">
                <button @click.prevent="submit()" :disabled="creating" type="button" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 min-w-[200px]">
                    {{ submitText }}
                </button>
            </div> -->
    </template>
  </MediumModal>
</template>

<script>
import MediumModal from '@/Components/Modals/MediumModal.vue'
import { XCircleIcon, SearchIcon, ChevronDownIcon } from '@heroicons/vue/solid'
import { PlusCircleIcon, MinusCircleIcon, CalendarIcon, ExclamationCircleIcon } from '@heroicons/vue/outline'
import { useForm } from '@inertiajs/vue3'
import getsErrors from '@/Mixins/getsErrors'
import { Calendar, DatePicker } from 'v-calendar'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'

export default {
  mixins: [getsErrors],

  components: {
    MediumModal,
    XCircleIcon,
    SearchIcon,
    PlusCircleIcon,
    MinusCircleIcon,
    ChevronDownIcon,
    CalendarIcon,
    ExclamationCircleIcon,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Calendar,
    DatePicker
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    actionText: {
      type: String,
      default: 'Save'
    }
  },

  emits: ['update:open', 'created'],

  data() {
    return {
      creating: false,
      searchQuery: null,
      searching: false,
      searchResults: false,
      package: null,
      quantity: null,
      transferRows: [],
      date: new Date()
    }
  },

  watch: {
    searchQuery(newVal, oldVal) {
      if (!newVal) {
        this.clearSearch()
      } else if (!this.selectedPackage || this.selectedPackage.id !== newVal) {
        this.clearSelectedPackage()
        this.search()
      }
    }
  },

  setup() {
    const form = useForm({
      package: null,
      quantity: null
    })

    return { form }
  },

  computed: {
    errors() {
      return this.$page.props.errors.createTransfer || {}
    },
    submitText() {
      if (this.creating) {
        return 'Saving...'
      }

      return this.actionText
    }
  },

  methods: {
    close() {
      this.$emit('update:open', false)
    },
    submit() {
      this.creating = true

      this.form.post(route('transfers.store'), {
        errorBag: 'createTransfer',
        onSuccess: (response) => {
          this.form.reset()
          this.emitCreated()
          this.creating = false
        },
        onFinish: (response) => {
          this.creating = false
        }
      })
    },
    search: _.debounce(
      function () {
        this.searching = true

        axios.post(route('packages.search'), { query: this.searchQuery }).then((response) => {
          this.searchResults = response.data.data || []
          this.searching = false
        })
      },
      500,
      {
        leading: false,
        trailing: true
      }
    ),
    selectPackage(item) {
      this.selectedPackage = item
      // this.clearSearch();
    },
    clearSearch() {
      this.searchQuery = null
      this.searchResults = []
      this.searching = false
    },
    clearSelectedPackage() {
      this.selectedPackage = null
    },
    clearAll() {
      this.clearSearch()
      this.clearSelectedPackage()
    },
    emitCreated() {
      this.$emit('created')
    }
  }
}
</script>
